import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LoaderService } from '@app/core/services/loader/loader.service';
import { CommonService } from '@app/shared/services/common/common.service';
import { MessageService } from '@app/shared/services/common/message.service';
import { ColorScheme } from '../../models/themePalette';
import { SocialUrl } from '../../models/social';
import { ILayoutSettings, IPageContent, ISocialLinks } from '@app/feature/store-editor/components/layout/store-editor.interface';
import IStoreGetDetailsInterface = namespace.IStoreGetDetailsInterface;
import { UserRoles } from '@app/shared/constants';

@Component({
  selector: 'app-user-layout',
  templateUrl: './user-layout.component.html',
  styleUrls: ['./user-layout.component.css']
})
export class UserLayoutComponent implements OnInit {

  storeNameUrl: string;
  socialLinks: ISocialLinks;
  layoutSettings: ILayoutSettings;
  constructor(private commonService: CommonService, private route: Router, private activatedRoute: ActivatedRoute) {

    this.activatedRoute.params.subscribe(params => {
      this.storeNameUrl = params['storename'];
      // localStorage.clear();

      // check if logged in user role is EndUser or StoreAdmin, If not logged out the user
      // Applied this logic because it was causing pricing issue on product detail page
      let userRole = localStorage.getItem('role');
      if(userRole && userRole != UserRoles.EndUser && userRole != UserRoles.StoreAdmin && userRole != UserRoles.StoreOwner && userRole != UserRoles.StoreStaffMember)
        localStorage.clear();

    });

    this.route = route;
    this.route.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };
  }

  ngOnInit() {
    this.layoutSettings = {
      maxWidth: 1224,
      color: '#1fb999',
      header: {
        logo: '/assets/img/Merch-Loop4.png',
        bgColor: 'rgb(255 255 255)',
        colorLink: '#1fb999',
        paddingOnSides: 10,
        IsDefaultLogo: true
      },
      footer: {
        logo: '/assets/img/Merch-Loop4.png',
        bgColor: 'rgb(255 255 255)',
        colorLink: '#1fb999',
        paddingOnSides: 10,
        IsDefaultLogo: true
      }
    };
    this.getDesignSetting();

    if (localStorage.getItem('ForceChangePassword') == 'true') {
      setTimeout(() => this.fn_ForceChangePassword());
    }
  }

  fn_ForceChangePassword() {
    if (location.href.toLowerCase().indexOf("profile") == -1) {
      this.route.navigate(['/' + this.storeNameUrl + '/profile']);
    }
  }

  coder() {
    return {
      decode: function (data: string): { layoutSettings: any, pageContent: any } {
        try {
          return JSON.parse(data);
        } catch (e) {
          return null;
        }
      },
      encoder: function (layoutSettings: any, pageContent: any) {
        return JSON.stringify({ layoutSettings, pageContent });
      }
    };
  }

  getDesignSetting() {
    this.commonService.getStoreByName(this.storeNameUrl).subscribe((res: IStoreGetDetailsInterface) => {
      if (res.Data.ResponseData) {

        localStorage.setItem('storeId', res.Data.ResponseData.StoreId.toString());
        localStorage.setItem('storeName', res.Data.ResponseData.StoreName);
        localStorage.setItem('storeUrl', res.Data.ResponseData.StoreUrl);
        localStorage.setItem('canEndUserCustomize', res.Data.ResponseData.CanEndUserCustomize ? 'true' : 'false');
        this.fn_UpdateDailyVistor();
        const design = this.coder().decode(res.Data.ResponseData.DesignSetting);
        if (design) {
          this.layoutSettings = design.layoutSettings;
        } else {
          this.layoutSettings = {
            maxWidth: 1224,
            color: '#1fb999',
            header: {
              logo: '/assets/img/Merch-Loop4.png',
              bgColor: 'rgb(255 255 255)',
              colorLink: '#1fb999',
              paddingOnSides: 10,
              IsDefaultLogo: true
            },
            footer: {
              logo: '/assets/img/Merch-Loop4.png',
              bgColor: 'rgb(255 255 255)',
              colorLink: '#1fb999',
              paddingOnSides: 10,
              IsDefaultLogo: true
            }
          };
        }
        if (res.Data.ResponseData.StoreSocialMedia) {
          this.socialLinks = {
            YouTubeUrl: res.Data.ResponseData.StoreSocialMedia.YouTubeUrl,
            FacebookUrl: res.Data.ResponseData.StoreSocialMedia.FacebookUrl,
            TwitterUrl: res.Data.ResponseData.StoreSocialMedia.TwitterUrl,
            InstagramUrl: res.Data.ResponseData.StoreSocialMedia.InstagramUrl,
          };
        }
        else {
          this.socialLinks = {
            YouTubeUrl: '',
            FacebookUrl: '',
            TwitterUrl: '',
            InstagramUrl: '',
          };
        }
      } else {
        if (res.StatusCode == 405) {
          this.route.navigate(['/404storenotonline']);
        } else {
          this.route.navigate(['404NotFound']);
        }

        
        
      }
    });
  }

  /** Func to update daily visitor of store */
  fn_UpdateDailyVistor() {
    this.commonService.updateDailyVistor(localStorage.getItem('storeId')).subscribe((res: any) => { }, (err: any) => { });
  }
}
